export const SPA_SESSION_KEYS = {
    isUAEPassSPAUserLoginWithEmail : "isUAEPassSPAUserLoginWithEmail",
    UAEPassSPAUserEmail: "UAEPassSPAUserEmail",
    spaRecordId: "spaRecordId",
    spaUAEPassError: "spaUAEPassError",
    spaUAEPassAuthSuccess: "spaUAEPassAuthSuccess",
};

export const checkIsUAEPassSPAUserLoginWithEmail = (clearSession = false) => {
    const value = sessionStorage.getItem(SPA_SESSION_KEYS.isUAEPassSPAUserLoginWithEmail) === 'true';
    if(clearSession) {
        sessionStorage.removeItem(SPA_SESSION_KEYS.isUAEPassSPAUserLoginWithEmail);
    }
    return value;
};

export const checkIsEmailSameInUAEPass = (email: string, clearSession = false) => {
    const emailFromSession = sessionStorage.getItem(SPA_SESSION_KEYS.UAEPassSPAUserEmail);
    if(clearSession) {
        sessionStorage.removeItem(SPA_SESSION_KEYS.UAEPassSPAUserEmail);
    }
    return emailFromSession === email;
};

export const getSPARecordIdFromSession = () => {
    return sessionStorage.getItem(SPA_SESSION_KEYS.spaRecordId);
};

export const getSPAUAEPassError = (clearSession = false) => {
    const errorMessage = sessionStorage.getItem(SPA_SESSION_KEYS.spaUAEPassError);
    if(clearSession) {
        sessionStorage.removeItem(SPA_SESSION_KEYS.spaUAEPassError);
    }
    return errorMessage;
};

export const checkIsUAEAuthSuccess = (clearSession = false) => {
    const isAuthSuccess = sessionStorage.getItem(SPA_SESSION_KEYS.spaUAEPassAuthSuccess) === "true";
    if(clearSession) {
        sessionStorage.removeItem(SPA_SESSION_KEYS.spaUAEPassAuthSuccess);
    }
    return isAuthSuccess;
};

export const clearSPAUAEAuthSessionVariables = () => {
    sessionStorage.removeItem(SPA_SESSION_KEYS.isUAEPassSPAUserLoginWithEmail);
    sessionStorage.removeItem(SPA_SESSION_KEYS.UAEPassSPAUserEmail);
    sessionStorage.removeItem(SPA_SESSION_KEYS.spaRecordId);
    sessionStorage.removeItem(SPA_SESSION_KEYS.spaUAEPassError);
    sessionStorage.removeItem(SPA_SESSION_KEYS.spaUAEPassAuthSuccess);
}

export const isLoginViaUAEPass = (custom_uuid : string|null) =>{
    if(custom_uuid && custom_uuid.length) 
        return true 
    else false;
}